// Image proxy via wsrv.nl to reduce Supabase Storage egress. Disable without redeploy by setting REACT_APP_IMAGE_PROXY_ENABLED=false.
export function optimizeImage(url, { width = 800, height, fit, quality = 80, output = 'webp', we } = {}) {
  if (!url || typeof url !== 'string') return url;
  if (process.env.REACT_APP_IMAGE_PROXY_ENABLED === 'false') return url;
  if (!url.startsWith('http://') && !url.startsWith('https://')) return url;
  if (url.includes('wsrv.nl')) return url;

  const h = height ? `&h=${height}` : '';
  const f = fit ? `&fit=${fit}` : '';
  const noEnlarge = we ? '&we' : '';
  return `https://wsrv.nl/?url=${encodeURIComponent(url)}&w=${width}${h}${f}${noEnlarge}&output=${output}&q=${quality}`;
}

// Preset for product cards in listings: 400px wide.
export const productCard = (url) => optimizeImage(url, { width: 400 });

// Preset for product listing grid (homepage): 800px wide covers ~365px CSS slots at DPR=2; we prevents upscale.
export const productListing = (url) => optimizeImage(url, { width: 800, quality: 85, we: true });

// Preset for artist gallery figures: 1080px wide matches typical source resolution; we prevents upscale.
export const productGallery = (url) => optimizeImage(url, { width: 1080, quality: 85, we: true });

// Preset for product detail page: 1000px wide.
export const productDetail = (url) => optimizeImage(url, { width: 1000 });

// Preset for artist hero showcase: 1400px wide, q=85 for illustration-grade sharpness.
export const heroShowcase = (url) => optimizeImage(url, { width: 1400, quality: 85 });

// Preset for thumbnails (bag, gallery, admin): 150px wide.
export const thumbnail = (url) => optimizeImage(url, { width: 150 });

// Preset for artist avatar (circular, 200px CSS @ DPR=2 → 480px square crop).
export const artistAvatar = (url) => optimizeImage(url, { width: 600, height: 600, fit: 'cover', quality: 85 });

// Generate a ~1KB thumbnail from any wsrv.nl proxied URL for use as a blur-up placeholder.
// Returns null for non-proxied URLs so callers can fall back gracefully.
export function getPlaceholderUrl(proxiedUrl) {
  if (!proxiedUrl || typeof proxiedUrl !== 'string') return null;
  if (!proxiedUrl.includes('wsrv.nl')) return null;
  try {
    const parsed = new URL(proxiedUrl);
    const originalUrl = parsed.searchParams.get('url');
    if (!originalUrl) return null;
    return optimizeImage(originalUrl, { width: 20, quality: 20, output: 'webp' });
  } catch {
    return null;
  }
}
